import styled, {css, CSSProperties} from 'styled-components'
import {RadioStepsProps} from './RadioSteps'

export const StyledRadioStepsWrapper = styled.div<{
    $fullWidth?: boolean
}>(
    ({theme: {palette, shadows}, $fullWidth = false}) => css`
        display: flex;
        align-items: stretch;
        justify-content: start;
        border-radius: 6px;
        overflow: hidden;
        outline: 1px solid ${palette.neutral['200']};
        width: ${$fullWidth ? '100%' : 'fit-content'};
        box-shadow: ${shadows.sm};
    `
)

const makeInputStepSizeStyle = () =>
    ({
        sm: css`
            min-height: 28px;
        `,
        md: css`
            min-height: 32px;
        `
    }) as const satisfies Record<NonNullable<RadioStepsProps['size']>, ReturnType<typeof css>>

export const StyledRadioStepLabel = styled.label<{
    $isSelected?: boolean
    $size: RadioStepsProps['size']
    $itemWidth?: CSSProperties['width']
}>(
    ({theme, $isSelected, $size = 'md', $itemWidth}) => css`
        ${theme.typography.textSm};
        min-width: 58px;
        width: ${$itemWidth};
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: ${theme.spacing}px ${theme.spacing * 2.5}px;
        cursor: pointer;
        ${makeInputStepSizeStyle()[$size]}
        ${$isSelected
            ? css`
                  background-color: ${theme.palette.primary['500']};
                  color: ${theme.palette.neutral.white};
              `
            : css`
                  background-color: ${theme.palette.neutral.white};
                  color: ${theme.palette.neutral['600']};
                  transition: ${theme.transition};
                  &:hover {
                      background-color: ${theme.palette.neutral['50']};
                  }
              `}
    `
)
